import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import i18n from '@/locales/index';
import router from './router';
import '@/scss/index.scss';
import '@/scss/element-variables.scss';

Vue.config.productionTip = false
// UI
Vue.use(ElementUI, {
  size: 'small'
});

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
